/**
 * 사용하는 스타일 속성값을 정의
 */
export const styleTags = {
    align: 'text-align',
    marginLeft: 'margin-left',
    marginRight: 'margin-right',
    textIndent: 'text-indent',
    borderLeft: 'border-left',
    borderRight: 'border-right',
    borderTop: 'border-top',
    borderBottom: 'border-bottom',
    backColor: 'background-color',
    foreColor: 'color',
    size: 'font-size',
    width: 'width',
    height: 'height',
    backImage: 'background-image',
    // rows: 'table',
    // cells: 'tr',
    // rowspan: 'rowspan',
    // colspan: 'colspan',
    padding: 'padding',
    // path: 'path',
    float: 'float',
    left: 'left',
    top: 'top',
};
